import React from 'react';
import styled from 'styled-components';
import Theme from '../StyledComponentThemes';

import { IconShared } from './StyledComponents/Icons/Icons.jsx';

export const BadgeContainer = styled.span`
    display: flex;
    font-family: 'Helvetica Neue', helvetica, sans-serif;
    font-size: 11px;
    font-weight: ${p => (p.bold ? '600' : '400')};
    letter-spacing: 0.5px;
    text-transform: none;
    text-align: center;
    color: ${p => (p.color === '#e5e5e5' ? Theme.defaultGray : '#FFF')};
    background: ${p => p.color};
    position: relative;
    border-radius: 2px;
    padding: ${p => (p.padding ? p.padding : '3px 6px')};
    margin: ${p => (p.margin ? p.margin : '0px')};
    line-height: 1;
    flex-direction: row;
    ${p => p.marginBottom && 'margin-bottom: 6px'};
    ${p => p.invert && `background: #FFF; color: ${Theme.blue};`}
    &:hover {
        cursor: ${p => (p.hasTooltip ? 'pointer' : 'inherit')};
    }
    width: fit-content;
    max-width: 100%;
`;

const LabelContainer = styled.span`
    max-width: ${p => (p.maxWidth ? p.maxWidth : '90%')};
    text-overflow: ellipsis;
    overflow: hidden;
    width: ${p => (p.width ? p.width : '90%')};
    padding: 1px 0px;
`;

const Tooltip = styled.div`
    visibility: ${p => (p.isShown ? 'visible' : 'hidden')};
    opacity: ${p => (p.isShown ? '1' : '0')};
    position: absolute;
    background: #fff;
    box-shadow: 0 3px 8px rgba(140, 140, 140, 0.5);
    padding: 8px;
    width: 210px;
    color: #637582;
    border-radius: 3px;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    text-align: left;
    transition: ease 0.3s all;
    line-height: 16px;
    &::after,
    &::before {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid #fff;
        bottom: -8px;
        display: block;
        left: 50%;
        transform: translateX(-50%);
    }
    &::before {
        bottom: -9px;
        border-top: 8px solid rgba(140, 140, 140, 0.2);
    }
`;

const LeftTooltip = styled(Tooltip)`
    left: 0;
    transform: none;
    &::before,
    &::after {
        left: 20px;
    }
`;

const RightTooltip = styled(Tooltip)`
    left: auto;
    transform: none;
    right: 0;
    &::before,
    &::after {
        right: 20px;
        left: auto;
    }
`;

export default class Badge extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showToolTip: false,
        };
    }

    onMouseEnter = () => {
        this.setState({
            showTooltip: true,
        });
    };

    onMouseLeave = () => {
        this.setState({
            showTooltip: false,
        });
    };

    render() {
        let colorHex, tooltip;
        const {
            /*eslint-disable react/prop-types*/
            bold,
            color,
            hasTooltip,
            icon,
            invert,
            label,
            margin,
            padding,
            width,
            maxWidth,
            tooltipAlign,
            tooltipMessage,
            /*eslint-enable react/prop-types*/
        } = this.props;

        switch (color) {
            case 'green':
                colorHex = '#67A422';
                break;
            case 'red':
                colorHex = '#E94B35';
                break;
            case 'light-gray':
                colorHex = '#e5e5e5';
                break;
            case 'dark-gray':
                colorHex = '#919FAB';
                break;
            default:
                colorHex = Theme.defaultGray;
        }

        const iconJSX =
            icon === 'shared' ? (
                <IconShared
                    width="16px"
                    height="8px"
                    color={colorHex === '#e5e5e5' ? Theme.defaultGray : '#FFF'}
                    margin="0 4px 0 0"
                />
            ) : null;

        switch (tooltipAlign) {
            case 'left':
                tooltip = (
                    <LeftTooltip isShown={this.state.showTooltip}>
                        {tooltipMessage}
                    </LeftTooltip>
                );
                break;
            case 'right':
                tooltip = (
                    <RightTooltip isShown={this.state.showTooltip}>
                        {tooltipMessage}
                    </RightTooltip>
                );
                break;
            default:
                tooltip = (
                    <Tooltip isShown={this.state.showTooltip}>
                        {tooltipMessage}
                    </Tooltip>
                );
        }

        return (
            <BadgeContainer
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
                color={colorHex}
                invert={invert}
                margin={margin}
                padding={padding}
                bold={bold}
                hasTooltip={hasTooltip}
            >
                {iconJSX && iconJSX}
                <LabelContainer maxWidth={maxWidth} width={width}>
                    {label}
                </LabelContainer>
                {hasTooltip && tooltip}
            </BadgeContainer>
        );
    }
}
